export default __webpack_public_path__ + "static/media/02__o_preview_5.12d7f51c.jpg";